import { appEmail, appUpsellUrl } from './appApi';

export const pushUpsaleForApp = async (id, email, paypalIds = []) => {
  if (!id || !email) return;

  // Разглаживаем массив на один уровень и фильтруем ложные значения
  const course_ids = Array.isArray(id)
    ? id.flat().filter(Boolean)
    : [];

  if (course_ids.length === 0) return;

  const data = {
    email: appEmail(email),
    course: course_ids
  };
  // A PayPal upsell bought after the account exists (QA-97): the server checks this id with PayPal.
  const ids = (paypalIds || []).filter(Boolean);
  if (ids.length) data.paypal_id = ids;

  const response = await fetch(appUpsellUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text);
  }
}

/**
 * QA-97: the app account is made before the upsells, so an upsell bought on a later screen is added to it at once.
 * Before the account exists nothing is sent (registration sends the collected upsells). A failure never stops
 * the buyer; it is logged.
 */
export const grantUpsellNow = async (userData, courseId, paypalId = null) => {
  if (userData?.registration !== 'completed' || !userData?.appEmail) return false;
  const ids = Array.isArray(courseId) ? courseId : [courseId];
  try {
    await pushUpsaleForApp(ids, userData.appEmail, paypalId ? [paypalId] : []);
    return true;
  } catch (error) {
    console.error('Upsell grant failed:', error);
    return false;
  }
};
